export const valueType = (value) => {
  if (value === 'NaN') {
    return 'NaN';
  }
  if (value === null) {
    return 'null';
  }
  if (Array.isArray(value)) {
    return 'array';
  }
  if (typeof value === 'object') {
    return 'object';
  }
  return typeof value;
};

export const sortByObjValues = (a, b, data) => {
  const typeA = valueType(data[a]);
  const typeB = valueType(data[b]);

  // if (typeA === 'array' && typeB !== 'array') return -1;

  if ((typeA === 'object' || typeA === 'array') && (typeB !== 'object' || typeB !== 'array'))
    return 1;
  if ((typeA !== 'object' || typeA !== 'array') && (typeB === 'object' || typeB === 'array'))
    return -1;
  if ((typeA === 'object' || typeA === 'array') && (typeB === 'object' || typeB === 'array'))
    return 0;
};

export const updateDynamicObject = (data, path, updateValue) => {
  const dataType = valueType(data);
  const pathValue = path.shift();

  if (pathValue === undefined) {
    return data;
  }

  if (path.length === 0) {
    if (dataType === 'array') {
      const duplicateArray = data.slice();
      duplicateArray[pathValue] = updateValue;
      return duplicateArray;
    }
    if (dataType === 'object') {
      return {
        ...data,
        [pathValue]: updateValue
      };
    }
  }
  if (dataType === 'array') {
    const duplicateArray = data.slice();
    duplicateArray[pathValue] = updateDynamicObject(data[pathValue], path, updateValue);
    return duplicateArray;
  }
  return {
    ...data,
    [pathValue]: updateDynamicObject(data[pathValue], path, updateValue)
  };
};
